import { Filter } from "./filter";
import { FilterGroup } from "./filterGroup";
export class MatchAny extends FilterGroup {
  constructor(override filters: Array<Filter>) {
    super("match.any", filters);
  }
}
